import { ReactNode, useEffect, useState } from "react";

/**
 * Renders its children only after mounting on the client. During SSR and the
 * first client render it renders nothing, so browser-only widgets (toasters,
 * Intercom, the env badge, the upload indicator) never run on the server and
 * never cause a hydration mismatch.
 */
const ClientOnly = ({ children }: { children: ReactNode }) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted ? <>{children}</> : null;
};

export default ClientOnly;
